import { render, staticRenderFns } from "./QuotesButton.vue?vue&type=template&id=2210a654&"
import script from "./QuotesButton.vue?vue&type=script&lang=js&"
export * from "./QuotesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2210a654')) {
      api.createRecord('2210a654', component.options)
    } else {
      api.reload('2210a654', component.options)
    }
    module.hot.accept("./QuotesButton.vue?vue&type=template&id=2210a654&", function () {
      api.rerender('2210a654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/JobOffers/QuotesButton.vue"
export default component.exports